import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Colors } from "../../styles/colors";
import styles from "./LTooltip.module.css";

type Direction = "up" | "down" | "downRight";

const getDirection = (direction: Direction): string => {
    switch (direction) {
        case "up":
            return styles.up;
        case "down":
            return styles.down;
        case "downRight":
            return styles.downRight;
        default:
            return styles.up;
    }
};

export const LTooltip = ({
    text,
    icon = "circle-info",
    color = Colors.darkGray2,
    direction = "down"
}: LTooltipProps): JSX.Element => {
    const textParagraphs = text.split("\\n");
    return (
        <div className={styles.tooltip}>
            {icon === "circle-info" && (
                <FontAwesomeIcon icon={solid("circle-info")} size="lg" color={color} className="mr-2" />
            )}
            {icon === "warning" && <FontAwesomeIcon icon={solid("warning")} size="lg" color={color} className="mr-2" />}
            <span className={`${styles.tooltipText} ${getDirection(direction)} has-text-left`}>
                <div>
                    {textParagraphs.map((x, idx) => {
                        return (
                            <p key={idx} className="mt-2">
                                {x}
                            </p>
                        );
                    })}
                </div>
            </span>
        </div>
    );
};

interface LTooltipProps {
    text: string;
    icon?: "circle-info" | "warning";
    color?: string;
    direction?: Direction;
}
